import React from "react";

const EditNoteIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="edit_note_icon"
      data-name="edit note"
      {...props}
      width={props.width || "20"}
      height={props.height || "20"}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.83398 14.1775L9.51148 14.165L17.5381 6.21496C17.8532 5.89996 18.0265 5.48163 18.0265 5.03663C18.0265 4.59163 17.8532 4.17329 17.5381 3.85829L16.2165 2.53663C15.5865 1.90663 14.4873 1.90996 13.8623 2.53413L5.83398 10.4858V14.1775ZM15.0381 3.71496L16.3623 5.03413L15.0315 6.35246L13.7098 5.03163L15.0381 3.71496ZM7.50065 11.1808L12.5257 6.20329L13.8473 7.52496L8.82315 12.5008L7.50065 12.505V11.1808Z"
        fill={props.fill || "#3A8AB9"}
      />
      <path
        d="M4.16667 17.5H15.8333C16.7525 17.5 17.5 16.7525 17.5 15.8333V8.61L15.8333 10.2767V15.8333H6.79833C6.77667 15.8333 6.75417 15.8417 6.7325 15.8417C6.705 15.8417 6.6775 15.8342 6.64917 15.8333H4.16667V4.16667H9.8725L11.5392 2.5H4.16667C3.2475 2.5 2.5 3.2475 2.5 4.16667V15.8333C2.5 16.7525 3.2475 17.5 4.16667 17.5Z"
        fill={props.fill || "#3A8AB9"}
      />
    </svg>
  );
};

export default EditNoteIcon;
